<template>
  <div class="exchange_account">
    <h3>계좌정보</h3>
    <p class="description">본인 계좌번호만 신청이 가능합니다.</p>
    <dl>
      <dt>계좌주</dt>
      <dd>{{ exchangeInit.userName }}</dd>
    </dl>
    <dl>
      <dt>은행선택</dt>
      <dd class="form">
        <custom-selectbox
          @custom-select="updateBankName"
          :value="bankSelect"
          :items="bankNameList"
          firstItem="은행 선택"
        />
      </dd>
    </dl>
    <dl>
      <dt>계좌번호</dt>
      <dd class="form">
        <v-input-number
          v-model="exchangeAccountRequest.accountNo"
          @custom-input="updateAccountNo"
          @custom-enter="handleClick"
        />
        <v-button class="btn03" @handleClick="handleClick" :disabled="isStateAccount" text="인증" />
      </dd>
      <dd class="msg" :class="msgClass">
        <v-icon clsName="icon_check" />
        <v-icon clsName="icon_error" />
        {{ errorMsg }}
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInputNumber from '@/components/atoms/VInputNumber';
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';

export default {
  components: {
    VInputNumber,
    CustomSelectbox,
    VButton,
    VIcon,
  },
  data() {
    return {
      errorMsg: '',
      errorCode: '',
      msgClass: '',
      prevAccount: '',
    };
  },
  computed: {
    ...mapGetters('exchange', [
      'bankNameList',
      'exchangeInit',
      'bankSelect',
      'exchangeAccountRequest',
      'exchangeRequest',
      'isStateAccount',
    ]),
  },
  methods: {
    ...mapActions('exchange', ['setBankName', 'setAccountNo', 'checkBankAccount']),
    updateBankName(val) {
      this.setBankName(val);
      this.checkAccount();
    },
    updateAccountNo(val) {
      this.setAccountNo(val);
      this.checkAccount();
    },
    checkAccount() {
      if (
        this.prevAccount != '' &&
        this.prevAccount.bankCode != this.exchangeAccountRequest.bankCode + this.exchangeAccountRequest.accountNo
      ) {
        this.msgClass = 'red';
        this.errorMsg = '계좌정보가 변경 되어 다시 인증하셔야 합니다.';
      }
    },
    async handleClick() {
      if (this.bankSelect === -1) {
        this.msgClass = 'red';
        this.errorMsg = '은행을 선택하세요.';
        return;
      }
      if (!this.exchangeAccountRequest.accountNo) {
        this.msgClass = 'red';
        this.errorMsg = '계좌번호를 입력하세요.';
        return;
      }
      const apiReturn = await this.checkBankAccount(this.exchangeAccountRequest);
      this.errorCode = apiReturn.code;
      if (apiReturn.code > 0) {
        this.msgClass = 'red';
        this.errorMsg = '본인 계좌 번호만 입력 가능합니다.';
      } else if (apiReturn.code === 0) {
        this.msgClass = 'blue';
        this.errorMsg = '본인 계좌 번호로 확인되었습니다.';
        this.prevAccount = this.exchangeAccountRequest.bankCode + this.exchangeAccountRequest.accountNo;
      }
    },
  },
};
</script>
<style lang="scss"></style>
